import _ from 'lodash';
import axios from 'axios';

const ROOT = 'data/items/';
const THUMB = 'php/thumbnail.php?img='

const request = axios.get(ROOT + 'items.json')
	.then(
		resp => resp.data
	).then(
		items => _.forEach(items, (item, idx) => {
			item.id = idx + '';
			item.next = items[(idx + 1) % items.length];
			item.previous = items[(idx - 1 + items.length) % items.length];
			item.pictures = _.map(item.pictures, url => ROOT + url);
			item.thumbnail = item.thumbnail || {};
			item.thumbnail.url = item.thumbnail.url ? (ROOT + item.thumbnail.url) : (THUMB + item.pictures[0]);
		})
	)
	.then(
		items => { console.log('loaded', items); return items; }
	);

export default {

	getItems () {
		return request;
	},
	
	getItem (id) {
		return request.then(items => items[id]);
	}

};
